(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["brands"] && !window.DesignMode) return;
  try {
    
$('.owl-carousel').owlCarousel({
    loop:true,
    margin:65,
    nav:false,
    autoplay: true,
    dots:false,
    responsive:{
        0:{
            items:3
        },
        600:{
            items:3
        },
        1000:{
            items:5
        }
    }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

$('#search-icon').click(function() {
    if ($('body').hasClass('search-open')) {
        $('body').removeClass('search-open');
    } else {
        $('body').addClass('search-open');
    }
});

$('#search-icon-mobile').click(function() {
    if ($('body').hasClass('search-open')) {
        $('body').removeClass('search-open');
    } else {
        $('body').addClass('search-open');
    }
});

$('#overlay-search').click(function(){
	$('body').removeClass('search-open');
});


$('#overlay-menu').click(function(){
	$('body').removeClass('open-show-menu');
});

$('#overlay-menu').click(function(){
	$('.nav-wrapper').removeClass('show-menu');
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-history"]) return;
  try {
    
 $(document).ready(function(){
   	$(".nav-tabs li:first-child").addClass("active");
   	$(".tab-content .tab-pane:first-child").addClass("active");
   	$(".tab-content .tab-pane:first-child .panel-collapse").addClass("in");
 });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-rrhh"]) return;
  try {
    
    (function() {

        var formulario = document.test,
            elementos = formulario.elements;

        // Funcion que se ejecuta cuando el evento click es activado
        var validarInputs = function() {
            for (var i = 0; i < elementos.length; i++) {
                // Identificamos si el elemento es de tipo texto, email, password, radio o checkbox

                if (elementos[i].type == "text" || elementos[i].type == "email" || elementos[i].type == "tel" || elementos[i].id == "ContactFormMessage") {
                    // Si es tipo texto, email o password vamos a comprobar que esten completados los input
                    if (elementos[i].value.length == 0) {
                        console.log('El campo ' + elementos[i].name + ' esta incompleto');
                        elementos[i].className = elementos[i].className + " error";
                        return false;
                    } else {
                        elementos[i].className = elementos[i].className.replace(" error", "");
                    }
                }
            }

            // Comprobando que las contraseñas coincidan
            if (elementos.pass.value !== elementos.pass2.value) {
                elementos.pass.value = "";
                elementos.pass2.value = "";
                elementos.pass.className = elementos.pass.className + " error";
                elementos.pass2.className = elementos.pass2.className + " error";
            } else {
                elementos.pass.className = elementos.pass.className.replace(" error", "");
                elementos.pass2.className = elementos.pass2.className.replace(" error", "");
            }

            return true;
        };

        var enviar = function(e) {
            if (!validarInputs()) {
                console.log('Falto validar los Input');
                e.preventDefault();
            } else if (!validarRadios()) {
                console.log('Falto validar los Radio Button');
                e.preventDefault();
            } else if (!validarCheckbox()) {
                console.log('Falto validar Checkbox');
                e.preventDefault();
            } else {
                console.log('Envia');
                e.preventDefault();
            }
        };

        var focusInput = function() {
            this.parentElement.children[1].className = "label active";
            this.parentElement.children[0].className = this.parentElement.children[0].className.replace("error", "");
        };

        var blurInput = function() {
            if (this.value <= 0) {
                this.parentElement.children[1].className = "label";
                this.parentElement.children[0].className = this.parentElement.children[0].className + " error";
            }
        };

        // --- Eventos ---
        formulario.addEventListener("submit", enviar);

        for (var i = 0; i < elementos.length; i++) {
            if (elementos[i].type == "text" || elementos[i].type == "email" || elementos[i].type == "tel" || elementos[i].id == "ContactFormMessage") {
                elementos[i].addEventListener("focus", focusInput);
                elementos[i].addEventListener("blur", blurInput);
            }
        }

    }())

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-rrhh23"]) return;
  try {
    
    (function() {

        var formulario = document.test,
            elementos = formulario.elements;

        // Funcion que se ejecuta cuando el evento click es activado
        var validarInputs = function() {
            for (var i = 0; i < elementos.length; i++) {
                // Identificamos si el elemento es de tipo texto, email, password, radio o checkbox

                if (elementos[i].type == "text" || elementos[i].type == "email" || elementos[i].type == "tel" || elementos[i].id == "ContactFormMessage") {
                    // Si es tipo texto, email o password vamos a comprobar que esten completados los input
                    if (elementos[i].value.length == 0) {
                        console.log('El campo ' + elementos[i].name + ' esta incompleto');
                        elementos[i].className = elementos[i].className + " error";
                        return false;
                    } else {
                        elementos[i].className = elementos[i].className.replace(" error", "");
                    }
                }
            }

            // Comprobando que las contraseñas coincidan
            if (elementos.pass.value !== elementos.pass2.value) {
                elementos.pass.value = "";
                elementos.pass2.value = "";
                elementos.pass.className = elementos.pass.className + " error";
                elementos.pass2.className = elementos.pass2.className + " error";
            } else {
                elementos.pass.className = elementos.pass.className.replace(" error", "");
                elementos.pass2.className = elementos.pass2.className.replace(" error", "");
            }

            return true;
        };

        var enviar = function(e) {
            if (!validarInputs()) {
                console.log('Falto validar los Input');
                e.preventDefault();
            } else if (!validarRadios()) {
                console.log('Falto validar los Radio Button');
                e.preventDefault();
            } else if (!validarCheckbox()) {
                console.log('Falto validar Checkbox');
                e.preventDefault();
            } else {
                console.log('Envia');
                e.preventDefault();
            }
        };

        var focusInput = function() {
            this.parentElement.children[1].className = "label active";
            this.parentElement.children[0].className = this.parentElement.children[0].className.replace("error", "");
        };

        var blurInput = function() {
            if (this.value <= 0) {
                this.parentElement.children[1].className = "label";
                this.parentElement.children[0].className = this.parentElement.children[0].className + " error";
            }
        };

        // --- Eventos ---
        formulario.addEventListener("submit", enviar);

        for (var i = 0; i < elementos.length; i++) {
            if (elementos[i].type == "text" || elementos[i].type == "email" || elementos[i].type == "tel" || elementos[i].id == "ContactFormMessage") {
                elementos[i].addEventListener("focus", focusInput);
                elementos[i].addEventListener("blur", blurInput);
            }
        }

    }())

  } catch(e) { console.error(e); }
})();

})();
